import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { excludeSurchargeDisclaimerPolicies } from "@/features/policies/shared/policy-member-visibility";
import { useTenantData } from "@/hooks";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";

const PUBLIC_WAIVERS_PAGE = 1;
const PUBLIC_WAIVERS_PAGE_SIZE = 1000;

export const useWaiversGetPublic = () => {
  const { tenantId } = useTenantData();

  const { data, isError, isLoading, isPending, isFetching, isSuccess, refetch, error } =
    useQuery({
      queryKey: [
        QueryKeys.Waivers,
        tenantId,
        "public",
        PUBLIC_WAIVERS_PAGE,
        PUBLIC_WAIVERS_PAGE_SIZE,
      ],
      queryFn: () => {
        const service = new WaiversPoliciesApi(createOpenApiConfiguration());
        return service.apiPoliciesScrollGet({
          page: PUBLIC_WAIVERS_PAGE,
          pageSize: PUBLIC_WAIVERS_PAGE_SIZE,
          active: true,
          xTenantID: tenantId,
        });
      },
      enabled: tenantId > 0,
      staleTime: 5 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,
    });

  const items = useMemo(
    () => excludeSurchargeDisclaimerPolicies(data?.items),
    [data?.items],
  );

  return {
    ...data,
    items,
    isError,
    isLoading,
    isPending,
    isFetching,
    isSuccess,
    refetch,
    error,
  };
};
